import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'prod_id': {
    title: '生产计划单号',
    type: 'input',
    equation: cusname
  },
  'type': {
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0006'
  },
  'salescenter': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  'partner': {
    title: '订单客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    },
    unSearchRole: 'WLY001'
  },
  'name': {
    title: '客户名称',
    type: 'input',
    equation: all,
    unSearchRole: 'WLY001'
  },
  'status': {
    title: '单据状态',
    type: 'select',
    equation: city,
    dictionary: 'A0008'
  },
  'product_name': {
    title: '产品名称',
    type: 'input',
    equation: all
  },
  'uname': {
    title: '创建人',
    type: 'input',
    equation: all
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all
  }
}

export const config1 = {
  'prodpl_id': {
    title: '生产计划单号',
    slot: true
  },
  'prodpltype': {
    title: '计划类型'
  },
  'name_soldto': {
    title: '客户',
    width: 'auto'
  },
  'centerktx': {
    title: '营销单元'
  },
  'datum': {
    title: '创建日期'
  },
  'uname': {
    title: '创建人'
  },
  'remark': {
    title: '备注'
  },
  'status': {
    title: '状态'
  }
}

export const config2 = {
  'prodpl_id': {
    title: '生产计划单号',
    slot: true
  },
  'prodpl_item': {
    title: '项目',
    width: 70
  },
  'prod_id': {
    title: '产品',
    width: 200
  },
  'wlybrand': {
    title: '品牌'
  },
  'description': {
    title: '描述',
    width: 400
  },
  'planqty_box': {
    title: '数量(件)'
  },
  'planqty_bottle': {
    title: '数量(瓶)'
  },
  'planqty_ton': {
    title: '数量(吨)'
  },
  'prodsum_id': {
    title: '汇总计划号'
  },
  'lastconfm_qty': {
    title: '最终确认(件)'
  },
  'area': {
    title: '区域'
  },
  'status': {
    title: '单据状态'
  }

}



// WEBPACK FOOTER //
// ./src/views/make-plan-manage/config/makePlanQuery.js